import { CSSProperties, ReactNode } from 'react';
import { Typography } from 'antd';

export const sectionIconStyle: CSSProperties = {
    color: 'var(--brand-6)',
    fontSize: 16,
};

type Props = {
    text: string;
    icon: ReactNode;
};

const SectionTitle = ({ icon, text }: Props) => (
    <Typography style={{ fontWeight: 600, marginBottom: 2, lineHeight: '22px' }}>
        {icon} {text}
    </Typography>
);

export default SectionTitle;
